import * as React from 'react';
import IAsset from '../../models/asset';
import Asset from '../../models/asset';
import AssetPanel from '../../panels/assets';
import Config, { ListOptions } from './config';
import { Accordion, Input, Button, Modal, Form, Icon, Label, Dropdown, Header, Grid } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import OAuth, { AxiosErrorMessage } from '../../api';
import update from 'immutability-helper';
import '../../css/config.css';
import '../../panels/panels.css';
import Toggle from 'react-toggle';
import * as ReactTooltip from 'react-tooltip';							 								  
const _ = require('lodash');

interface ModalConfirmOptions {
    headerText: string;
    content: (options: ModalConfirmOptions) => React.ReactNode | string;
    ConfirmButton?: string;
    CancelButton?: string;
    value?: string;

    // if the user clicks OK then the onAccept() handler is called
    // the original event and data  object are bound to the onAccept() at show-time
    onAccept: (event?: any, data?: any) => void;
}

class State {
    hideAdvanced: boolean;
    readOnly: boolean;
    assets ?: Array<IAsset>;
    assetName ?: string;
    selectedAliasName?: string;
    searchString ?: string;
    currentIndex ?: number;
    openModal ?: boolean;
    newAsset: Asset;
    modalHeader: string;
    modalContent: string;
    setOptions: ListOptions[];
    vodTemplates: ListOptions[];
    confirmation?: ModalConfirmOptions;
    activeIndexes: number[];
    headers?: any;
    showHeaderModal?: boolean;
    variants?: any;
    autostart?: string;
    showVariantsModal?: boolean;
    currentOptions?: any;
    numOptions?: any;
    speedModalOpen?: boolean;
    dashQoEAudioSubRep?: boolean;
    dashAutoStartSubRep: boolean;
    dashDecrypt: boolean;
    hlsDecrypt: boolean;
    hssDecrypt: boolean;
    audioVariants: string;
    QoELicensePresent: boolean;
    currentAsset: any;
    nextAsset: any;
    nextIndex ?: number;
    nextName ?: string;
    showModal: boolean;
    respText: any;
    showErr: boolean;
    isError: boolean;
}

interface Props {
    confirmation: boolean;
}

export default class VODAssetAliasView extends React.Component<Props, State> {

    public static defaultProps: Partial<Props> = {
        confirmation: true
    };
    private hlsTypeOptions = [ { text: 'Master Playlist', value: 'me1' }, { text: 'Media Playlist', value: 'me2'}, { text: 'Media', value: 'me3' }, { text: 'Key', value: 'me4' }];
    private hssTypeOptions =  [ { text: 'Manifest', value: 'me1' }, { text: 'Media', value: 'me2'} ];
    // private hdsTypeOptions =  [ { text: 'Manifest', value: 'me1' }, { text: 'Bootstrap', value: 'me2'}, { text: 'Media', value: 'me3' } ];
    private dashTypeOptions =  [ { text: 'MPD', value: 'me1' }, { text: 'Media', value: 'me2'} ];
    private hlsStatusOptions = [ { value: 'bw=', text: 'Bandwidth' }, { value: 'res=', text: 'Resolution' }, { value: 'm=', text: 'Media' }, { value: 'a=', text: 'Audio'}, { value: 'i=', text: 'I-Frame' }, { value: 's=', text: 'Subtitle' }];
    private hssStatusOptions = [ { value: 'bw=', text: 'Bandwidth' }, { value: 'res=', text: 'Resolution' }, { value: 'v=', text: 'Video' }, { value: 'a=', text: 'Audio'} ];
    // private hdsStatusOptions = [ { value: 'bw=', text: 'Bandwidth' }, { value: 'res=', text: 'Resolution' }, { value: 'v=', text: 'Video' } ];
    private dashStatusOptions = [ { value: 'bw=', text: 'Bandwidth'}, { value: 'res=', text: 'Resolution' }, { value: 'v=', text: 'Video' }, { value: 'a=', text: 'Audio'}, { value: 'i=', text: 'Image' }, { value: 't=', text: 'Text' }];
    private videoOptions = [ { value: 'pos', text: 'Position'} ];
    private audioOptions = [ { value: 'pos', text: 'Position'}, { value: 'lang', text: 'Language'}];
    private textOptions = [ { value: 'pos', text: 'Position'}, { value: 'lang', text: 'Language'}];
    private opOptions = [ { value: '=', text: '='}, { value: '!=', text: '!='}, { value: '>', text: '>'}, { value: '>=', text: '>='}, { value: '<', text: '<'}, { value: '<=', text: '<='} ];
    // private resOptions = [ { value: '240', text: '240'}, { value: '360', text: '360'}, { value: '480', text: '480'}, { value: '720', text: '720'}, { value: '1080', text: '1080'},  { value: '1440', text: '1440'}, { value: '2160', text: '2160'}, { value: '4320', text: '4320'} ];

    private confirmDeleteAll = this.showConfirmation.bind(this, {
        headerText: 'Delete All Assets',
        ConfirmButton: 'Delete All',
        content: 'All VOD asset aliases will be deleted from the system. Do you want to continue?',
        onAccept: this.deleteAllAliases
    });

    private confirmSave = this.showConfirmation.bind(this, {
        headerText: 'Save Asset',
        ConfirmButton: 'Save',
        content: 'All changes will be saved to the system. Do you want to continue?',
        onAccept: this.updateAliases
    });

    private confirmSaveAs = this.showConfirmation.bind(this, {
        headerText: 'Save Alias As',
        ConfirmButton: 'Add',
        content: (options: ModalConfirmOptions) => (
            <Form.Field>
                <label>Provide a name for the new alias: (no duplicate names allowed)</label>
                <Input
                    placeholder="VOD Alias Name"
                    defaultValue={this.state.selectedAliasName}
                    value={this.state.confirmation ? this.state.confirmation.value : ''}
                    onChange={(event: any, data: any) => this.setState((prevState: any) => ({
                        confirmation: {
                            ...prevState.confirmation,
                            value: data.value
                        }
                    }))
                    }
                />
            </Form.Field>
        ),
        onAccept: this.saveAs
    });

    private confirmDelete = this.showConfirmation.bind(this, {
        headerText: 'Delete',
        content: 'VOD Asset alias will be deleted from the system. Do you want to continue?',
        ConfirmButton: 'Delete',
        onAccept: this.deleteAlias
    });

    static compare(a: any, b: any) {
        // Use toUpperCase() to ignore character casing
        const genreA = a.name.toUpperCase();
        const genreB = b.name.toUpperCase();

        let comparison = 0;
        if (genreA > genreB) {
            comparison = 1;
        } else if (genreA < genreB) {
            comparison = -1;
        }
        return comparison;
    }

    componentWillMount() {
        this.setState({
            hideAdvanced: false,
            readOnly: false,
            openModal: false,
            modalHeader: 'Delete',
            modalContent: '',
            setOptions: [],
            vodTemplates: [],
            newAsset: Asset.VodAsset(),
            activeIndexes: [],
            currentIndex: 0,
            headers: [],
            showHeaderModal: false,
            variants: [],
            autostart: '',
            showVariantsModal: false,
            currentOptions: [],
            numOptions: 0,
            speedModalOpen: false,
            dashQoEAudioSubRep: false,
            dashAutoStartSubRep: false,
            selectedAliasName: '',
            dashDecrypt: false,
            hlsDecrypt: false,
            hssDecrypt: false,
            audioVariants: '',
            QoELicensePresent: false,
            currentAsset: null,
            nextAsset: null,
            nextIndex: 0,
            assetName: '',
            nextName: '',
            showModal: false,
            respText: '',
            showErr: false,
            isError: false
        });
        this.handleModalClose = this.handleModalClose.bind(this);
        this.addAlias = this.addAlias.bind(this);
        this.updateAliases = this.updateAliases.bind(this);
        this.deleteAllAliases = this.deleteAllAliases.bind(this);
        this.deleteAlias = this.deleteAlias.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleAssetClick = this.handleAssetClick.bind(this);
        this.handleHeaderModalClose = this.handleHeaderModalClose.bind(this);
        this.handleVariantsModalClose = this.handleVariantsModalClose.bind(this);
        this.setSpeedModalOpen = this.setSpeedModalOpen.bind(this);
        this.handleWarningClose = this.handleWarningClose.bind(this);
        this.handleErrModalClose = this.handleErrModalClose.bind(this);
    }

    componentDidMount() {
        this.fetchData('SABR', true);
        this.fetchSetOptions();
        this.fetchTemplateOptions();
        this.fetchGlobalConfigData();

        let oauth;

        if (window.sessionStorage && (oauth = window.sessionStorage.getItem('oauth'))) {
            let result = JSON.parse(oauth);
            if (result.QoELicensePresent) {
                this.setState({QoELicensePresent: true});
            } else {
                this.setState({QoELicensePresent: false});
            }
        } else {
            this.setState({QoELicensePresent: false});
        }
    }

    handleWarningClose() {
        this.setState({
          showModal: false
        });
    }

    handleModalClose() {
        this.setState({
            openModal: false
        });
    }

    // Set the Speed help Modal to open/closed
    setSpeedModalOpen(isOpen: boolean) {
        this.setState({speedModalOpen: isOpen});
    }

    filterList = (event: any) => {
        this.setState({searchString: event.target.value});
    }

    clearFilter = () => {
        this.setState({searchString: ''});
    }

    renderCustomHeaderFields(streamType: string) {
        let type: any;
        if (streamType === 'DASH') {
            type = this.dashTypeOptions;
        // } else if (streamType === 'HDS') {
        //     type = this.hdsTypeOptions;
        } else if (streamType === 'HLS Master' || streamType === 'HLS Component') {
            type = this.hlsTypeOptions;
        } else if (streamType === 'HSS') {
            type = this.hssTypeOptions;
        }

        let options = [];
        for (let idx = 0; idx < Object.keys(this.state.headers).length; idx++) {
            let typeId = `type-${idx}`, valId = `val-${idx}`;
            options.push((
                <div>
                    <Label className="variantLabel" >
                        Request Type
                    </Label>
                     <Dropdown
                         className="templateDropDown1"
                         search
                         selection
                         name={typeId}
                         data-id={idx}
                         id={typeId}
                         options={type}
                         value={this.state.headers[idx].type}
                         onChange={(event, data) => this.handleHeaderTypeDataChange(event, idx, streamType)}
                     />
                     <Input
                         className="customHeaderValue"
                         type="textarea"
                         placeholder="Value"
                         name={valId}
                         data-id={idx}
                         id={valId}
                         value={this.state.headers[idx].value}
                         onChange={(event) => this.handleValueDataChange(event, idx)}
                     />
                    <Button
                        className="resetButton"
                        icon={<Icon name="trash alternate outline" color={'red'} link />}
                        content="Remove"
                        title="Remove"
                        onClick={(e, data) => this.removeHeader(idx)}
                    />
                </div>
                ));
        }
        return <div>{options}</div>;
    }

    // Request Type
    handleHeaderTypeDataChange (event: any, index: any, streamType: string) {
        let headers = [...this.state.headers];

        if (streamType === 'HLS Master' || streamType === 'HLS Component') {
            if (event.target.innerText === 'Master Playlist') {
                headers[index].type = 'me1';
            } else if (event.target.innerText === 'Media Playlist') {
                headers[index].type = 'me2';
            } else if (event.target.innerText === 'Media' ) {
                headers[index].type = 'me3';
            } else if (event.target.innerText === 'Key' ) {
                headers[index].type = 'me4';
            }
        // } else if (streamType === 'HDS') {
        //     if (event.target.innerText === 'Manifest') {
        //         headers[index].type = 'me1';
        //     } else if (event.target.innerText === 'Bootstrap') {
        //         headers[index].type = 'me2';
        //     } else if (event.target.innerText === 'Media' ) {
        //         headers[index].type = 'me3';
        //     }
        } else if (streamType === 'HSS') {
            if (event.target.innerText === 'Manifest') {
                headers[index].type = 'me1';
            } else if (event.target.innerText === 'Media') {
                headers[index].type = 'me2';
            }
        } else if (streamType === 'DASH') {
            if (event.target.innerText === 'MPD') {
                headers[index].type = 'me1';
            } else if (event.target.innerText === 'Media') {
                headers[index].type = 'me2';
            }
        }
        this.setState({headers}, () => this.modify({headerModified: true}));
        // this.setState({headers}, () => console.log(this.state.headers));
    }

    // Header Value
    handleValueDataChange (event: any, index: any) {
        let headers = [...this.state.headers];

        headers[index].value = event.target.value;

        this.setState({headers}, () => this.modify({headerModified: true}));
    }

    // Add Default entry for custom header
    addHeader(index: any) {
        this.setState((prevState) => ({
            headers: [...prevState.headers, {key: index + 1, id: index + 1, type: 'me1', value: ''}]
        }),           () => this.modify({headerModified: true}));
    }

    // Remove all headers
    removeHeaders() {
        let headers: never[] = [];
        this.setState({headers}, () => this.modify({headerModified: true}));
    }
    // Remove current header
    removeHeader(index: any) {
        let headers = [...this.state.headers]; // make a separate copy of the array
        headers.splice(index, 1);
        this.setState({headers}, () => this.modify({headerModified: true}));
    }
    // Operator Type
    handleOperatorHDataChange (event: any, data: any, index: any) {
        let variants = [...this.state.variants];
        variants[index].operatorH = data.value;

        this.setState({variants}, () => this.modify({variantModified: true}));
        // this.setState({variants}, () => console.log(this.state.variants));
    }
    // Operator Type
    handleOperatorWDataChange (event: any, data: any, index: any) {
        let variants = [...this.state.variants];
        variants[index].operatorW = data.value;

        this.setState({variants}, () => this.modify({variantModified: true}));
        // this.setState({variants}, () => console.log(this.state.variants));
    }
    // Resolution Type
    handleResHDataChange (event: any, data: any, index: any) {
        let variants = [...this.state.variants];
        variants[index].resh = data.value;

        this.setState({variants}, () => this.modify({variantModified: true}));
        // this.setState({variants}, () => console.log(this.state.variants));
    }
    // Resolution Type
    handleResWDataChange (event: any, data: any, index: any) {
        let variants = [...this.state.variants];
        variants[index].resw = data.value;

        this.setState({variants}, () => this.modify({variantModified: true}));
        // this.setState({variants}, () => console.log(this.state.variants));
    }
    // Method Type
    handleMethodDataChange (event: any, data: any, index: any) {
        let variants = [...this.state.variants];
        variants[index].method = data.value;

        this.setState({variants}, () => this.modify({variantModified: true}));
        // this.setState({variants}, () => console.log(this.state.variants));
    }
    // Variant Type
    handleTypeDataChange (event: any, data: any, index: any) {
        let variants = [...this.state.variants];
        if (data.value !== 'res=') {
            if (data.value !== 'bw') {
                variants[index].method = 'pos';
            }
            variants[index].type = data.value;
            this.setState({variants}, () => this.modify({variantModified: true}));
            // this.setState({variants}, () => console.log(this.state.variants));
        } else {
            variants[index].type = data.value;
            variants[index].operatorH = '=';
            variants[index].resh = '';
            variants[index].type = data.value;
            variants[index].operatorW = '=';
            variants[index].resw = '';
            this.setState({variants}, () => this.modify({variantModified: true}));
        }
    }
    // Variant BW
    handleBWDataChange (event: any, index: any) {
        let variants = [...this.state.variants];

        variants[index].bw = event.target.value;

        this.setState({variants}, () => this.modify({variantModified: true}));
        // this.setState({variants}, () => console.log(this.state.variants));
    }
    // Variant Tolerance
    handleToleranceDataChange (event: any, index: any) {
        let variants = [...this.state.variants];

        variants[index].tol = event.target.value;

        this.setState({variants}, () => this.modify({variantModified: true}));
        // this.setState({variants}, () => console.log(this.state.variants));
    }
    // Variant Position
    handlePositionDataChange (event: any, index: any) {
        let variants = [...this.state.variants];

        variants[index].pos = event.target.value;

        this.setState({variants}, () => this.modify({variantModified: true}));
        // this.setState({variants}, () => console.log(this.state.variants));
    }
    // Variant Language
    handleLanguageDataChange (event: any, index: any) {
        let variants = [...this.state.variants];

        variants[index].lang = event.target.value;

        this.setState({variants}, () => this.modify({variantModified: true}));
        // this.setState({variants}, () => console.log(this.state.variants));
    }
    // Add Default entry for Video variant
    addVariant(index: any, streamType: string) {
        this.setState((prevState) => ({
            currentOptions: this.findOptions(streamType),
            variants: [...prevState.variants, {id: index + 1, type: '', method: '', pos: '', lang: '',  bw: '', tol: '', operatorH: '', operatorW: '', resh: '', resw: '', videoToggle: false, pixelToggle: false, audioToggle: false}]
        }),           () => this.modify({variantModified: true}));
    }
    // Remove all variants
    removeVariants() {
        let variants: never[] = [];
        this.setState({variants}, () => this.modify({variantModified: true}));
    }
    // Remove current variant
    removeVariant(index: any) {
        // const variants = this.state.variants.filter((x: any, i: any) => i !== index);
        let variants = [...this.state.variants]; // make a separate copy of the array
        variants.splice(index, 1);
        this.setState({variants}, () => this.modify({variantModified: true}));
    }
    // extract variants from 'variants' string
    extractVariants(index: any) {
        let asset: (IAsset | null) = (this.state.assets !== undefined && this.state.currentIndex !== undefined)
            ? this.state.assets[index]
            : null;

        // console.log('extractVariants()');

        let autostart = '';
        if (asset) {
            // console.log('index: ' + index);

            let dashQoEAudioSubRep = asset.qoeAudioVariants !== undefined ? asset.qoeAudioVariants.includes('sr=true') ? true : false : false;
            let expression = asset ? asset.variants : '';

            autostart = expression.startsWith('all') ? 'all' : expression === '' ? '' : 'custom';

            let dashAutoStartSubRep = false;

            // SAN-4258
            let srIndex = 0;
            if (autostart === 'all' || autostart === 'custom') {
                if (expression.endsWith(';sr=true')) {
                    dashAutoStartSubRep = true;
                    srIndex = expression.indexOf(';sr=true');
                    expression = expression.substring(0, srIndex);
                }
            }

            // SAN-4517
            let audioVariants = '';
            if (asset.qoeAudioVariants !== undefined) {
                audioVariants = asset.qoeAudioVariants;
                if (audioVariants.includes('sr=true')) {
                    if (audioVariants.endsWith(',sr=true')) {
                        srIndex = audioVariants.indexOf(',sr=true');
                        audioVariants = audioVariants.substring(0, srIndex);
                    } else {
                        srIndex = audioVariants.indexOf('sr=true');
                        audioVariants = audioVariants.substring(0, srIndex);
                    }
                }
                this.setState({audioVariants});
            }
            // SAN-4517

            // console.log('autostart: ' + autostart);
            this.setState((prevState) => ({
                variants: [],
                autostart: autostart,
                dashQoEAudioSubRep,
                dashAutoStartSubRep
            }));

            // console.log('expression: ' + expression);

            if (autostart === 'custom') {
                // extract each token
                let config1 = expression.split(';');
                let config2: never[] | string[] = []; let settings = ''; let value = '';
                let config3: never[] | string[] = [];

                // SAN-5107
                let videoVariants = asset.qoeVideoVariants;
                let pixelVariants = asset.qoePixelVariants;

                for (let i = 0; i < Object.keys(config1).length; i++) {
                    let bwCfg = [];
                    let type = ''; let pos = ''; let lang = ''; let bw = ''; let tol = ''; let method = ''; let operator = '';
                    let operatorW = ''; let operatorH = ''; let resw = ''; let resh = '';
                    let videoToggle = false; let pixelToggle = false; let audioToggle = false;
                    // extract each value -> m=1,2,3 etc...
                    if (videoVariants !== undefined && videoVariants !== "") {
                        if (videoVariants.includes(config1[i])) {
                            videoToggle = true;
                        }
                    } else {
                        videoToggle = false;
                    }
                    if (pixelVariants !== undefined && pixelVariants !== "") {
                        if (pixelVariants.includes(config1[i])) {
                            pixelToggle = true;
                        }
                    } else {
                        pixelToggle = false;
                    }
                    if (audioVariants !== undefined && audioVariants !== "") {
                        if (audioVariants.includes(config1[i])) {
                            audioToggle = true;
                        }
                    } else {
                        audioToggle = false;
                    }
                    // SAN-5549
                    if (config1[i].includes('res=')) {
                        if (config1[i].includes('res=w')) {
                            settings = 'res=w';
                            if (config1[i].includes(',h')) {
                                settings = 'res=wh';
                            }
                        } else if (config1[i].includes('res=h')) {
                            settings = 'res=h';
                        }
                        // config1[i] = "res=w=1440,h=900"
                        config2 = config1[i].split(',');
                        for (let j = 0; j < Object.keys(config2).length; j++) {
                            if (config2[j].includes('!=')) {
                                operator = '!=';
                                config3 = config2[j].split('!=');
                                value = config3[1];
                            } else if (config2[j].includes('>=')) {
                                operator = '>=';
                                config3 = config2[j].split('>=');
                                value = config3[1];
                            } else if (config2[j].includes('<=')) {
                                operator = '<=';
                                config3 = config2[j].split('<=');
                                value = config3[1];
                            } else if (config2[j].includes('>')) {
                                operator = '>';
                                config3 = config2[j].split('>');
                                value = config3[1];
                            } else if (config2[j].includes('<')) {
                                operator = '<';
                                config3 = config2[j].split('<');
                                value = config3[1];
                            } else {
                                operator = '=';
                                config3 = config2[j].split('=');
                                if (config2[j].startsWith('h')) {
                                    value = config3[1];
                                } else {
                                    value = config3[2];
                                }
                            }
                            switch (settings) {
                                case 'res=wh':
                                    type = 'res=';
                                    if (j === 0) {
                                        operatorW = operator;
                                        resw = value;
                                    } else {
                                        operatorH = operator;
                                        resh = value;
                                    }
                                    break;
                                case 'res=w':
                                    type = 'res=';
                                    operatorW = operator;
                                    operatorH = '=';
                                    resw = value;
                                    break;
                                case 'res=h':
                                    type = 'res=';
                                    operatorW = '=';
                                    operatorH = operator;
                                    resh = value;
                                    break;
                                default:
                                    break;
                            }
                        }
                        this.setState((prevState) => ({
                            variants: [...prevState.variants, {
                            id: i,
                            type: type,
                            method: method,
                            pos: pos,
                            lang: lang,
                            bw: bw,
                            tol: tol,
                            operatorW: operatorW,
                            operatorH: operatorH,
                            resw: resw,
                            resh: resh,
                            videoToggle: videoToggle,
                            pixelToggle: pixelToggle,
                            audioToggle: audioToggle
                            }]
                        }));
                    } else {
                        config2 = config1[i].split('=');
                        settings = config2[0];
                        value = config2[1];
                    }

                    switch (settings) {
                        case 'bw':
                            type = 'bw=';
                            bwCfg = value.split('%');
                            bw = bwCfg[0];
                            tol = bwCfg[1];
                            method = '';
                            break;
                        case 'm':
                            type = 'm=';
                            pos = value;
                            method = 'pos';
                            break;
                        case 'v':
                            type = 'v=';
                            pos = value;
                            method = 'pos';
                            break;
                        case 'a':
                            type = 'a=';
                            if (value.match(/^\d/)) {
                                pos = value;
                                method = 'pos';
                            } else {
                                lang = value;
                                method = 'lang';
                            }
                            break;
                        case 't':
                            type = 't=';
                            if (value.match(/^\d/)) {
                                pos = value;
                                method = 'pos';
                            } else {
                                lang = value;
                                method = 'lang';
                            }
                            break;
                        case 's':
                            type = 's=';
                            if (value.match(/^\d/)) {
                                pos = value;
                                method = 'pos';
                            } else {
                                lang = value;
                                method = 'lang';
                            }
                            break;
                        case 'i':
                            type = 'i=';
                            pos = value;
                            method = 'pos';
                            break;
                        default:
                            break;
                    }

                    if (!config1[i].includes('res=')) {
                        this.setState((prevState) => ({
                                variants: [...prevState.variants, {
                                id: i,
                                type: type,
                                method: method,
                                pos: pos,
                                lang: lang,
                                bw: bw,
                                tol: tol,
                                operatorW: operatorW,
                                operatorH: operatorH,
                                resw: resw,
                                resh: resh,
                                videoToggle: videoToggle,
                                pixelToggle: pixelToggle,
                                audioToggle: audioToggle
                                }]
                        }));
                    }
                }
                // this.setState({variants}, () => console.log(this.state.variants));
            }
        }
    }

    findOptions(streamType: string) {
        switch (streamType) {
            case 'DASH':
                return this.dashStatusOptions;
            // case 'HDS':
            //     return this.hdsStatusOptions;
            case 'HLS Master':
                return this.hlsStatusOptions;
            case 'HLS Component':
                return this.hlsStatusOptions;
            case 'HSS':
                return this.hssStatusOptions;
            default:
                return this.hlsStatusOptions;
        }
    }

    extractOptions(index: any) {
        let asset: (IAsset | null) = (this.state.assets !== undefined && this.state.currentIndex !== undefined)
            ? this.state.assets[index]
            : null;

        if (asset) {
            let type: any;
            if (asset.streamType === 'DASH') {
                type = this.dashStatusOptions;
            // } else if (asset.streamType === 'HDS') {
            //     type = this.hdsStatusOptions;
            } else if (asset.streamType === 'HLS Master' || asset.streamType === 'HLS Component') {
                type = this.hlsStatusOptions;
            } else if (asset.streamType === 'HSS') {
                type = this.hssStatusOptions;
            } else {
                // tslint:disable-next-line:no-console
                console.log('streamType: ' + asset.streamType);
            }
            // console.log('streamType: ' + asset.streamType);
            this.setState({numOptions: type.length, currentOptions: type});
        }
    }

    transformVariants(type: number, asset: Asset | null) {
        let options = ''; let qoeAudioOptions = '';
        let videoVariants = ''; let pixelVariants = ''; let audioVariants = '';
        let newOption = ''; let qoeAudio = false; let qoeVideo = false; let qoePixel = false;
        if (asset !== null) {
            if (this.state.autostart === 'custom') {
                for (let i = 0; i < Object.keys(this.state.variants).length; i++) {
                    if (this.state.variants[i].type === 'bw=') {
                        let bw = this.state.variants[i].bw !== undefined && this.state.variants[i].bw !== '' ? this.state.variants[i].bw : '';
                        let tol = this.state.variants[i].tol !== undefined && this.state.variants[i].tol !== '' ? '%' + this.state.variants[i].tol : '%10';
                        if (bw !== '') {
                            newOption = this.state.variants[i].type + bw + tol + ';';
                            options += newOption;
                        }
                        if (this.state.variants[i].videoToggle) {
                            videoVariants += newOption;
                        }
                        if (this.state.variants[i].audioToggle) {
                            audioVariants += newOption;
                        }
                        if (this.state.variants[i].pixelToggle) {
                            pixelVariants += newOption;
                        }
                        newOption = '';
                    } else if (this.state.variants[i].type === 'res=') {
                        let resolution = this.state.variants[i].resw !== undefined && this.state.variants[i].resw !== '' ? this.state.variants[i].resw : '';
                        if (resolution !== '') {
                            newOption = 'res=w' + this.state.variants[i].operatorW + resolution;
                            resolution = this.state.variants[i].resh !== undefined && this.state.variants[i].resh !== '' ? this.state.variants[i].resh : '';
                            if (resolution !== '') {
                                newOption += ',h' + this.state.variants[i].operatorH + resolution + ';';
                            } else {
                                newOption += ';';
                            }
                            options += newOption;
                        } else {
                            resolution = this.state.variants[i].resh !== undefined && this.state.variants[i].resh !== '' ? this.state.variants[i].resh : '';
                            if (resolution !== '') {
                                newOption = 'res=h' + this.state.variants[i].operatorH + resolution + ';';
                                options += newOption;
                            }
                        }
                        if (this.state.variants[i].videoToggle) {
                            videoVariants += newOption;
                        }
                        if (this.state.variants[i].audioToggle) {
                            audioVariants += newOption;
                        }
                        if (this.state.variants[i].pixelToggle) {
                            pixelVariants += newOption;
                        }
                        newOption = '';
                } else if ((this.state.variants[i].type === 'm=' || this.state.variants[i].type === 'v=') && this.state.variants[i].method === 'pos') {
                    let pos = this.state.variants[i].pos !== undefined && this.state.variants[i].pos !== '' ? this.state.variants[i].pos : '';
                    if (pos !== '') {
                        newOption = this.state.variants[i].type + pos + ';';
                        options += newOption;
                    }
                    if (this.state.variants[i].videoToggle) {
                        videoVariants += newOption;
                        }
                        if (this.state.variants[i].audioToggle) {
                            audioVariants += newOption;
                        }
                    if (this.state.variants[i].pixelToggle) {
                        pixelVariants += newOption;
                    }
                    newOption = '';
                } else if (this.state.variants[i].type === 'a=' && this.state.variants[i].method === 'pos') {
                    let pos = this.state.variants[i].pos !== undefined && this.state.variants[i].pos !== '' ? this.state.variants[i].pos : '';
                    if (pos !== '') {
                        newOption = this.state.variants[i].type + pos + ';';
                        options += newOption;
                    }
                    if (this.state.variants[i].audioToggle) {
                        audioVariants += newOption;
                    }
                    newOption = '';
                } else if (this.state.variants[i].type === 'a=' && this.state.variants[i].method === 'lang') {
                        let lang = this.state.variants[i].lang !== undefined && this.state.variants[i].lang !== '' ? this.state.variants[i].lang : '';
                        if (lang !== '') {
                        newOption = this.state.variants[i].type + lang + ';';
                        options += newOption;
                    }
                    if (this.state.variants[i].audioToggle) {
                        audioVariants += newOption;
                    }
                    newOption = '';
                } else if (this.state.variants[i].type === 'i=' && this.state.variants[i].method === 'pos') {
                    let pos = this.state.variants[i].pos !== undefined && this.state.variants[i].pos !== '' ? this.state.variants[i].pos : '';
                    if (pos !== '') {
                        newOption = this.state.variants[i].type + pos + ';';
                        options += newOption;
                    }
                    newOption = '';
                } else if ((this.state.variants[i].type === 's=' || this.state.variants[i].type === 't=') && (this.state.variants[i].method === 'pos')) {
                        let pos = this.state.variants[i].pos !== undefined && this.state.variants[i].pos !== '' ? this.state.variants[i].pos : '';
                        if (pos !== '') {
                        newOption = this.state.variants[i].type + pos + ';';
                        options += newOption;
                    }
                    newOption = '';
                } else if ((this.state.variants[i].type === 's=' || this.state.variants[i].type === 't=') && (this.state.variants[i].method === 'lang')) {
                    let lang = this.state.variants[i].lang !== undefined && this.state.variants[i].lang !== '' ? this.state.variants[i].lang : '';
                    if (lang !== '') {
                        newOption = this.state.variants[i].type + lang + ';';
                        options += newOption;
                        }
                    }
                    newOption = '';
                }
            } else if (this.state.autostart === 'all') {
                options = 'all';
            }

            // add final formatting
            if (this.state.autostart === 'custom') {
                options = options.substring(0, options.length - 1);
                videoVariants = videoVariants.substring(0, videoVariants.length - 1);
                pixelVariants = pixelVariants.substring(0, pixelVariants.length - 1);
                audioVariants = audioVariants.substring(0, audioVariants.length - 1);
                if (videoVariants.length > 0) qoeVideo = true;
                if (pixelVariants.length > 0) qoePixel = true;
                if (audioVariants.length > 0) qoeAudio = true;
            } else {
                videoVariants = asset.qoeVideoVariants;
                pixelVariants = asset.qoePixelVariants;
                audioVariants = this.state.audioVariants;
                qoeAudio = asset.qoeAudio ? asset.qoeAudio === true ? true : false : false;
                qoeVideo = asset.qoeVideo ? asset.qoeVideo === true ? true : false : false;
                qoePixel = asset.qoePixel ? asset.qoePixel === true ? true : false : false;
            }
            // variants string
            if (options !== '') {
                if (asset.streamType === 'DASH' && this.state.dashAutoStartSubRep === true) {
                    options += ';sr=true';
                }
            }

            let qoePresent = asset.qoeAudio !== undefined ? true : false;

            // qoeAudioVariants string
            if (asset.streamType !== 'DASH') {
                qoeAudioOptions = audioVariants;
            } else {
                if (asset.streamType === 'DASH' && (qoePresent && qoeAudio === true) && this.state.dashQoEAudioSubRep === true) {
                    if (audioVariants !== '') {
                        // @ts-ignore
                        if (!(audioVariants.includes('sr=true'))) {
                            qoeAudioOptions = audioVariants + ',sr=true';
                        } else {
                            qoeAudioOptions = audioVariants;
                        }
                    } else {
                        qoeAudioOptions = 'sr=true';
                    }
                } else if (asset.streamType === 'DASH' && (qoePresent && qoeAudio === true) && this.state.dashQoEAudioSubRep === false) {
                    let srIndex = audioVariants.indexOf(',sr=true');
                    if (srIndex > 0) {
                        qoeAudioOptions = audioVariants.substring(0, srIndex);
                    } else {
                        if (audioVariants === 'sr=true') {
                            qoeAudioOptions = '';
                        } else {
                            qoeAudioOptions = audioVariants;
                        }
                    }
                } else if (asset.streamType === 'DASH' && (qoePresent && qoeAudio === false) && this.state.dashQoEAudioSubRep === false) {
                    let srIndex = audioVariants.indexOf(',sr=true');
                    if (srIndex > 0) {
                        qoeAudioOptions = audioVariants.substring(0, srIndex);
                    } else {
                        if (audioVariants === 'sr=true') {
                            qoeAudioOptions = '';
                        } else {
                            qoeAudioOptions = audioVariants;
                        }
                    }
                } else if (asset.streamType === 'DASH' && (qoePresent && qoeAudio === false) && this.state.dashQoEAudioSubRep === true) {
                    if (audioVariants !== '') {
                        // @ts-ignore
                        if (!(audioVariants.includes('sr=true'))) {
                            qoeAudioOptions = audioVariants + ',sr=true';
                        } else {
                            qoeAudioOptions = audioVariants;
                        }
                    } else {
                        qoeAudioOptions = 'sr=true';
                    }
                }
            }
        }
        // ensure variants string is not greater than 255 characters
        if (options.length > 255) {
            this.setState({showVariantsModal: true});
        } else {
            this.transformHeaders(type, options, videoVariants, pixelVariants, qoeAudioOptions, qoeAudio, qoeVideo, qoePixel);
        }
    }

    renderButtons(streamType: string) {
        let options = [];
        options.push((
            <Form.Group grouped>
             <Label className="right-align-label-width333" />
             {(this.state.autostart === 'custom') ?
                 <React.Fragment>
                     <Button
                         floated="left"
                         className="leftButtonCenter"
                         // disabled={Object.keys(this.state.variants).length < this.state.numOptions ? false : true}
                         content="Add"
                         title="Add Variant"
                         onClick={(e, data) => this.addVariant(Object.keys(this.state.variants).length, streamType)}
                     />
                     <Button
                         floated="left"
                         className="leftButton"
                         // disabled={asset ? Object.keys(this.state.variants).length === 0 ? true : false) : true}
                         disabled={Object.keys(this.state.variants).length === 0 ? true : false}
                         content="Remove All"
                         title="Remove All Variants"
                         onClick={(e, data) => this.removeVariants()}
                     />
                 </React.Fragment>  : ''}
             {(this.state.autostart === 'bw') ?
                 <React.Fragment>
                     <Button
                         floated="left"
                         className="leftButton"
                         disabled={Object.keys(this.state.variants).length < 5 ? false : true}
                         content="Add"
                         title="Add Variant"
                         onClick={(e, data) => this.addVariant(Object.keys(this.state.variants).length, streamType)}
                     />
                     <Button
                         floated="left"
                         className="leftButton"
                         // disabled={asset ? Object.keys(this.state.variants).length === 0 ? true : false) : true}
                         disabled={Object.keys(this.state.variants).length === 0 ? true : false}
                         content="Remove All"
                         title="Remove All Variants"
                         onClick={(e, data) => this.removeVariants()}
                     />
                 </React.Fragment> : '' }
            </Form.Group>
            ));

        return <div>{options}</div>;
    }

    renderQoEAudioSubRep(asset: Asset) {
        if (asset.streamType === 'DASH') {
            // tslint:disable-next-line:jsx-wrap-multiline
            return <div>
                <React.Fragment>
                    <Label className="right-align-label-width270" >
                        Audio Sub-Representations
                    </Label>
                    <Toggle
                        id="0"
                        className="config-checkbox"
                        disabled={!(this.state.dashAutoStartSubRep)}
                        checked={this.state.dashQoEAudioSubRep}
                        onChange={(event: any) => this.setState({dashQoEAudioSubRep: !this.state.dashQoEAudioSubRep})}
                        readOnly={this.state.readOnly}
                    />
                </React.Fragment>
            </div>;
        }
        return '';
    }

    renderQoeFields(asset: Asset) {
        if (this.state.autostart === 'all') {
            // tslint:disable-next-line:jsx-wrap-multiline
            return <div>
            <OAuth.Feature QoE>
                <div className="spacerFS"/>
                <fieldset id="fieldSet1" className="field-set">
                    <legend>Content Analysis (QoE)</legend>
                    {asset ? this.renderQoEAudioSubRep(asset) : []}
                    <Form.Group grouped>
                        <Label className="right-align-label-width270" >
                            Video
                        </Label>
                        <Toggle
                            id="37"
                            className="config-checkbox"
                            checked={asset ? asset.qoeVideo : false}
                            onChange={(event: any) => !asset.qoeVideo ? this.modify({qoeVideo: true}) : this.modify({qoeVideo: false, qoePixel: false})}
                            readOnly={this.state.readOnly}
                        />
                        <Input
                            className="customHeaderValue"
                            type="text"
                            value={asset ? asset.qoeVideoVariants : ''}
                            placeholder="e.g. 1,2,5"
                            onChange={(event, data) => this.modify({qoeVideoVariants: data.value})}
                            readOnly={this.state.readOnly}
                        />
                    </Form.Group>
                    <Form.Group grouped>
                        <Label className="right-align-label-width270" >
                            Video with Pixel
                        </Label>
                        <Toggle
                            id="50"
                            disabled={(!this.state.QoELicensePresent) || (asset ? !asset.qoeVideo : true)}
                            className={(!asset || !asset.qoeVideo) || (this.state.readOnly) || (!this.state.QoELicensePresent) ? 'config-disabled' : 'config-checkbox'}
                            checked={asset ? asset.qoePixel : false}
                            onChange={(event: any) => this.modify({qoePixel: !asset.qoePixel})}
                            readOnly={this.state.readOnly}
                        />
                        <Input
                            type="text"
                            className={(!asset || !asset.qoeVideo) || (this.state.readOnly) || (!this.state.QoELicensePresent) ? 'customHeaderValueDisabled' : 'customHeaderValue'}
                            value={asset ? asset.qoePixelVariants : ''}
                            placeholder="e.g. 1,2,5"
                            onChange={(event, data) => this.modify({qoePixelVariants: data.value})}
                            readOnly={this.state.readOnly}
                        />
                    </Form.Group>
                    <Form.Group grouped>
                        <Label className="right-align-label-width270" >
                            Audio
                        </Label>
                        <Toggle
                            id="38"
                            className="config-checkbox"
                            checked={asset ? asset.qoeAudio : false}
                            onChange={(event: any) => this.modify({qoeAudio: !asset.qoeAudio})}
                            readOnly={this.state.readOnly}
                        />
                        <Input
                            className="customHeaderValue"
                            type="text"
                            value={asset ? this.state.audioVariants : ''}
                            placeholder="e.g. eng,fra"
                            onChange={(event, data) => this.setState({audioVariants: data.value})}
                            readOnly={this.state.readOnly}
                        />
                    </Form.Group>
                </fieldset>
            </OAuth.Feature>
            </div>;
        }
        return '';
    }

    renderSubRepFields(asset: Asset) {
        if (asset.streamType === 'DASH' && this.state.autostart !== '') {
            if (this.state.autostart === 'all') {
                return <div>
                    <React.Fragment>
                        <Config.Checkbox
                            id="0"
                            caption="Enable Sub-Representations"
                            optional
                            hint={false}
                            checked={this.state.dashAutoStartSubRep}
                            onToggle={(value: boolean) => {
                                if (value === false) this.setState({dashQoEAudioSubRep: false});
                                this.setState({ dashAutoStartSubRep: value }, () => this.modify({variantModified: true}));
                            }}
                            readOnly={this.state.readOnly}
                        />
                    </React.Fragment>
                </div>;
            } else {
                return <div>
                    <React.Fragment>
                        <Config.Checkbox
                            id="0"
                            caption="Enable Sub-Representations"
                            optional
                            hint={false}
                            checked={this.state.dashAutoStartSubRep}
                            onToggle={(value: boolean) => {
                                if (value === false) this.setState({dashQoEAudioSubRep: false});
                                this.setState({ dashAutoStartSubRep: value }, () => this.modify({variantModified: true}));
                            }}
                            readOnly={this.state.readOnly}
                        />
                        <OAuth.Feature QoE>
                            <Label className="right-align-label-width300" >
                                Enable QoE Audio Sub-Representations
                            </Label>
                            <Toggle
                                id="0"
                                className="config-checkbox"
                                disabled={!(this.state.dashAutoStartSubRep)}
                                checked={this.state.dashQoEAudioSubRep}
                                onChange={(event: any) => this.setState({dashQoEAudioSubRep: !this.state.dashQoEAudioSubRep})}
                                readOnly={this.state.readOnly}
                            />
                        </OAuth.Feature>
                    </React.Fragment>
                </div>;
            }
        }
        return '';
    }

    toggleVideo(index: any) {
        let variants = [...this.state.variants];
        variants[index].videoToggle = !variants[index].videoToggle;
        if (!variants[index].videoToggle) {
            variants[index].pixelToggle = false;
        }

        this.setState({variants}, () => this.modify({variantModified: true}));
        // this.setState({variants}, () => console.log(this.state.variants));
    }

    togglePixel(index: any) {
        let variants = [...this.state.variants];
        variants[index].pixelToggle = !variants[index].pixelToggle;

        this.setState({variants}, () => this.modify({variantModified: true}));
        // this.setState({variants}, () => console.log(this.state.variants));
    }

    toggleAudio(index: any) {
        let variants = [...this.state.variants];
        variants[index].audioToggle = !variants[index].audioToggle;

        this.setState({variants}, () => this.modify({variantModified: true}));
        // this.setState({variants}, () => console.log(this.state.variants));
    }
    renderVariantsFields(asset: Asset) {
        let options = [];
        // console.log('Entering renderVariantsField...');
        // console.log(this.state.variants);
        if (this.state.autostart === 'custom') {
            for (let idx = 0; idx < Object.keys(this.state.variants).length; idx++) {
                // tslint:disable-next-line:max-line-length
                let typeId = `type-${idx}`, bwId = `bw-${idx}`, tolId = `tol-${idx}`, posId = `pos-${idx}`, langId = `lang-${idx}`, methodId = `method-${idx}`, operatorHId = `oph-${idx}`, operatorWId = `opw-${idx}`, resHId = `resh-${idx}`, resWId = `resw-${idx}`, videoId = `video-${idx}`, pixelId = `pixel-${idx}`, audioId = `audio-${idx}`;
                // tslint:disable-next-line:max-line-length
                let method = this.state.variants[idx].type === 'm=' || this.state.variants[idx].type === 'v=' || this.state.variants[idx].type === 'i=' ? this.videoOptions : this.state.variants[idx].type === 'a=' ? this.audioOptions : this.textOptions;

                options.push((
                    <Form.Group grouped>
                        {/*<Label className="right-align-label-width250" />*/}
                        <Label className="variantLabelAlias50" >
                            Type
                        </Label>
                        <Dropdown
                            className="templateDropDown6"
                            placeholder="Auto-Start Type"
                            search
                            selection
                            name={typeId}
                            data-id={idx}
                            id={typeId}
                            options={this.state.currentOptions}
                            value={this.state.variants[idx].type}
                            onChange={(event, data) => this.handleTypeDataChange(event, data, idx)}
                        />
                        {(this.state.variants[idx].type === 'res=') ?
                            <React.Fragment>
                                <Label className="variantLabelAlias30" >
                                    W
                                </Label>
                                <Dropdown
                                    className="templateDropDown4"
                                    placeholder={'Operator'}
                                    // defaultValue={'='}
                                    search
                                    selection
                                    name={operatorWId}
                                    data-id={idx}
                                    id={operatorWId}
                                    options={this.opOptions}
                                    value={this.state.variants[idx].operatorW}
                                    onChange={(event, data) => this.handleOperatorWDataChange(event, data, idx)}
                                />
                                <Input
                                    className="variantLangText20"
                                    type="number"
                                    placeholder={'width'}
                                    name={resWId}
                                    data-id={idx}
                                    id={resWId}
                                    hint="true"
                                    min="1"
                                    max="10000"
                                    value={this.state.variants[idx].resw}
                                    error={this.state.variants[idx].resw < 1 || this.state.variants[idx].resw > 10000}
                                    onChange={(event, data) => this.handleResWDataChange(event, data, idx)}
                                />
                                <Label className="variantLabelAlias30" >
                                    H
                                </Label>
                                <Dropdown
                                    className="templateDropDown5"
                                    placeholder={'Operator'}
                                    // defaultValue={'='}
                                    search
                                    selection
                                    name={operatorHId}
                                    data-id={idx}
                                    id={operatorHId}
                                    options={this.opOptions}
                                    value={this.state.variants[idx].operatorH}
                                    onChange={(event, data) => this.handleOperatorHDataChange(event, data, idx)}
                                />
                                <Input
                                    className="variantLangText20"
                                    type="number"
                                    placeholder={'height'}
                                    name={resHId}
                                    data-id={idx}
                                    id={resHId}
                                    hint="true"
                                    min="1"
                                    max="10000"
                                    value={this.state.variants[idx].resh}
                                    error={this.state.variants[idx].resh < 1 || this.state.variants[idx].resh > 10000}
                                    onChange={(event, data) => this.handleResHDataChange(event, data, idx)}
                                />
                            </React.Fragment>  : '' }
                        {(this.state.variants[idx].type !== 'bw=' && this.state.variants[idx].type !== 'res=' && this.state.variants[idx].type !== '') ?
                            <React.Fragment>
                                <Dropdown
                                    className="templateDropDown1"
                                    placeholder="Method"
                                    search
                                    selection
                                    name={methodId}
                                    data-id={idx}
                                    id={methodId}
                                    options={method}
                                    value={this.state.variants[idx].method}
                                    onChange={(event, data) => this.handleMethodDataChange(event, data, idx)}
                                />
                            </React.Fragment>  : '' }
                        {(this.state.variants[idx].type !== 'bw=' && this.state.variants[idx].type !== 'res=' && this.state.variants[idx].method === 'pos') ?
                            <React.Fragment>
                                <Input
                                    className="variantLangText"
                                    type="textarea"
                                    placeholder={'e.g. 1,2'}
                                    name={posId}
                                    data-id={idx}
                                    id={posId}
                                    maxLength={127}
                                    value={this.state.variants[idx].pos}
                                    onChange={(event) => this.handlePositionDataChange(event, idx)}
                                />
                            </React.Fragment>  : '' }
                        {((this.state.variants[idx].type === 'a=' || this.state.variants[idx].type === 's=' || this.state.variants[idx].type === 't=') && this.state.variants[idx].method === 'lang') ?
                            <React.Fragment>
                                <Input
                                    className="variantLangText"
                                    type="textarea"
                                    placeholder={'e.g. spa'}
                                    name={langId}
                                    data-id={idx}
                                    id={langId}
                                    value={this.state.variants[idx].lang}
                                    onChange={(event) => this.handleLanguageDataChange(event, idx)}
                                />
                            </React.Fragment>  : '' }
                        {(this.state.variants[idx].type === 'bw=') ?
                            <React.Fragment>
                                <Input
                                    className="variantBWText"
                                    type="textarea"
                                    placeholder={'e.g.689200'}
                                    name={bwId}
                                    data-id={idx}
                                    id={bwId}
                                    value={this.state.variants[idx].bw}
                                    onChange={(event) => this.handleBWDataChange(event, idx)}
                                />
                                <Label className="variantLabelAlias30" >
                                    Tol
                                </Label>
                                <Input
                                    className="variantLangText"
                                    type="number"
                                    placeholder={'10%'}
                                    name={tolId}
                                    data-id={idx}
                                    id={tolId}
                                    maxLength="3"
                                    hint="true"
                                    min="1"
                                    max="99"
                                    step="1"
                                    value={this.state.variants[idx].tol}
                                    onChange={(event) => this.handleToleranceDataChange(event, idx)}
                                />
                            </React.Fragment> : '' }
                        {(asset && asset.monitorMode !== 'Header Only') && (this.state.variants[idx].type === 'bw=' || this.state.variants[idx].type === 'res=' || this.state.variants[idx].type === 'm=' || this.state.variants[idx].type === 'v=') ?
                            <OAuth.Feature QoE>
                                <React.Fragment>
                                    <Label title="QoE Analysis" className="left-align-label-40">
                                        QoE:
                                    </Label>
                                    <Label title="Video Analysis" className="left-align-label-40">
                                        Video
                                    </Label>
                                    <Toggle
                                        id={videoId}
                                        className="config-checkbox"
                                        checked={this.state.variants[idx].videoToggle ? this.state.variants[idx].videoToggle : false}
                                        onChange={(event: any) => this.toggleVideo(idx)}
                                    />
                                    <Label title="Pixel Analysis" className="left-align-label-40">
                                        Pixel
                                    </Label>
                                    <Toggle
                                        id={pixelId}
                                        className="config-checkbox"
                                        disabled={(!this.state.QoELicensePresent) || (!this.state.variants[idx].videoToggle ? true : false)}
                                        checked={this.state.variants[idx].pixelToggle ? this.state.variants[idx].pixelToggle : false}
                                        onChange={(event: any) => this.togglePixel(idx)}
                                    />
                                    <Label title="Audio Analysis" className="left-align-label-40">
                                        Audio
                                    </Label>
                                    <Toggle
                                        id={audioId}
                                        className="config-checkbox"
                                        checked={this.state.variants[idx].audioToggle ? this.state.variants[idx].audioToggle : false}
                                        onChange={(event: any) => this.toggleAudio(idx)}
                                    />
                                </React.Fragment>
                            </OAuth.Feature> : '' }
                        {(asset && asset.monitorMode !== 'Header Only') && (this.state.variants[idx].type === 'a=') ?
                            <OAuth.Feature QoE>
                                <React.Fragment>
                                    <Label title="QoE Analysis" className="left-align-label-40">
                                        QoE:
                                    </Label>
                                    <Label title="Audio Analysis" className="left-align-label-50">
                                        Audio
                                    </Label>
                                    <Toggle
                                        id={audioId}
                                        className="config-checkbox"
                                        checked={this.state.variants[idx].audioToggle ? this.state.variants[idx].audioToggle : false}
                                        onChange={(event: any) => this.toggleAudio(idx)}
                                    />
                                </React.Fragment>
                            </OAuth.Feature> : '' }
                        <Button
                            className="resetButton"
                            icon={<Icon name="trash alternate outline" color={'red'} link />}
                            content=""
                            title="Remove"
                            onClick={(e, data) => this.removeVariant(idx)}
                        />
                    </Form.Group>
                ));
            }
        }
        return <div>{options}</div>;
    }

    validateURLIPv6(str: string): boolean {
        let url;
        try {
            url = new URL(str);
        } catch (e) {
            // do nothing
        }

        if (url) {
            return true;
        } else {
            return false;
        }
    }

    tooltipRenderer() {
        return <ReactTooltip effect="float" place="top" html={true} delayShow={250} offset={{top: 10, left: 10}} className="tool-tip-override-general"/>;
    }

    renderForm(asset: IAsset | Asset) {
        const typeOptions = [ {value: 'HLS Component', text: 'Apple HTTP Live Streaming - Variant' },
            {value: 'HLS Master', text: 'Apple HTTP Live Streaming - Master' },
            {value: 'HSS', text: 'Microsoft Smooth Streaming' },
            // {value: 'HDS', text: 'Adobe HTTP Dynamic Streaming' },
            {value: 'DASH', text: 'MPEG Dynamic Adaptive Streaming' }];

        const ipOptions = [ {value: 'ANY', text: 'Any' },
            {value: 'IPv4', text: 'IPv4 only' },
            {value: 'IPv6', text: 'IPv6 only' }];

        const isModified = asset ? asset.modified : false;
        const disableSave = ! (asset && asset.name && asset.name.length > 0 && asset.streamType && asset.streamType.length > 0 && asset.url && asset.url.length >= 16 && this.validateURLIPv6(asset.url));
        const isNew = asset === this.state.newAsset;
        const isError = this.state.isError;
        const { activeIndexes } = this.state;

        const globalDecryptionConfigDisabled = (asset && !((asset.streamType === 'DASH' && this.state.dashDecrypt) || ((asset.streamType === 'HLS Master' || asset.streamType === 'HLS Component') && this.state.hlsDecrypt) || 
            (asset.streamType === 'HSS' && this.state.hssDecrypt)));

        const decryptOptions = [{ value: 'disable', text: 'Disabled' },
            { value: 'static', text: 'Static' },
            { value: 'DRM system', text: 'DRM System' },
            { value: 'HLS AES-128', text: 'HLS AES-128' },
            { value: 'HLS SAMPLE-AES', text: 'HLS SAMPLE-AES' },
            { value: 'PlayReady', text: 'PlayReady' }
        ];
        const tooltip = disableSave ? 'Enter valid URL between 16 and 2048 characters' : '';

        return (
            <React.Fragment>
                <div>
                    { isNew || isError
                        ? <Config.LongText
                            id="."
                            className="floatLeft"
                            caption="Alias Name"
                            fieldWidth={300}
                            maxLength={255}
                            hint={false}
                            defaultValue={asset ? asset.name : ''}
                            onChange={(value: string) => this.modify({name: value})}
                        />
                        : <label className="floatLeft padding">Alias Name: {asset.name}</label>
                    }
                    <span className="separator" />
                    <div className="floatRight padding">
                        <Button
                            className="rightButton"
                            content="Save As"
                            title="Save as new alias"
                            disabled={disableSave}
                            onClick={() => {this.transformVariants(1, asset); this.setState({selectedAliasName: asset.name}); }}
                        />
                        <Button
                            className={isModified ? 'rightButtonBlue' : 'rightButton'}
                            content="Save"
                            title="Save Alias"
                            disabled={disableSave}
                            onClick={() => this.transformVariants(2, asset)}
                        />
                    </div>
                </div>
                <AxiosErrorMessage debugReport={false} />
                <div className="vertical-flex-main">
                <Config.Pane>
                    <Config.Section
                        id="playlist"
                        title="Asset Definition"
                    >
                        <Config.Section id="playlist-root" title="">
                            <Config.Name
                                id="."
                                caption="Name"
                                fieldWidth={500}
                                hint={false}
                                maxLength={255}
                                defaultValue={asset ? asset.assetName : ''}
                                onChange={(value: string) => this.modify({assetName: value})}
                                readOnly={this.state.readOnly}
                            />
                            <Config.List
                                id="."
                                caption="Type"
                                options={typeOptions}
                                hint={false}
                                defaultValue={asset ? asset.streamType : 'HLS Master'}
                                onChange={(value: any) => {
                                    // SAN-5560
                                    this.setState({ currentOptions: this.findOptions(value) });
                                    this.modify({streamType: value} );
                                }}
                                readOnly={this.state.readOnly}
                            />
                            <div data-tip={tooltip}>
                                {this.tooltipRenderer()}
                                <Config.UrlIPv6
                                    id="."
                                    className={asset ? asset.url.length < 16 ? 'validate invalid' : '' : ''}
                                    caption="URL"
                                    fieldWidth={750}
                                    maxLength={2048}
                                    hint={false}
                                    defaultValue={asset ? asset.url : ''}
                                    onChange={(value: string) => this.modify({url: value})}
                                    readOnly={this.state.readOnly}
                                />
                            </div>
                            <Config.List
                                id="4"
                                caption="IP Version"
                                options={ipOptions}
                                hint={false}
                                defaultValue={asset ? asset.ipVersion : 'ANY'}
                                onChange={(value: any) => this.modify({ipVersion: value})}
                                readOnly={this.state.readOnly}
                            />
                            <Accordion>
                                <Accordion.Title
                                    active={activeIndexes.includes(0)}
                                    index={0}
                                    onClick={this.handleClick}
                                >
                                    <Icon name="dropdown"/>
                                    Substitution
                                </Accordion.Title>
                                <Accordion.Content active={activeIndexes.includes(0)}>
                                    <Config.LongText
                                        id="."
                                        caption="Variant Host"
                                        fieldWidth={500}
                                        maxLength={127}
                                        hide={this.state.hideAdvanced}
                                        hint={false}
                                        defaultValue={asset ? asset.indexHostSubst : ''}
                                        onChange={(value: string) => this.modify({indexHostSubst: value})}
                                        readOnly={this.state.readOnly}
                                    />
                                    <Config.LongText
                                        id="."
                                        caption="Variant Path"
                                        fieldWidth={500}
                                        maxLength={1023}
                                        hide={this.state.hideAdvanced}
                                        hint={false}
                                        defaultValue={asset ? asset.indexPathSubst : ''}
                                        onChange={(value: string) => this.modify({indexPathSubst: value})}
                                        readOnly={this.state.readOnly}
                                    />
                                    <Config.LongText
                                        id="."
                                        caption="Media Host"
                                        fieldWidth={500}
                                        hide={this.state.hideAdvanced}
                                        maxLength={127}
                                        hint={false}
                                        defaultValue={asset ? asset.mediaHostSubst : ''}
                                        onChange={(value: string) => this.modify({mediaHostSubst: value})}
                                        readOnly={this.state.readOnly}
                                    />
                                    <Config.LongText
                                        id="."
                                        caption="Media Path"
                                        fieldWidth={500}
                                        maxLength={1023}
                                        hide={this.state.hideAdvanced}
                                        hint={false}
                                        defaultValue={asset ? asset.mediaPathSubst : ''}
                                        onChange={(value: string) => this.modify({mediaPathSubst: value})}
                                        readOnly={this.state.readOnly}
                                    />
                                    <Config.LongText
                                        id="."
                                        caption="Key Host"
                                        fieldWidth={500}
                                        maxLength={127}
                                        hide={this.state.hideAdvanced}
                                        hint={false}
                                        defaultValue={asset ? asset.keyHostSubst : ''}
                                        onChange={(value: string) => this.modify({keyHostSubst: value})}
                                        readOnly={this.state.readOnly}
                                    />
                                    <Config.LongText
                                        id="."
                                        caption="Key Path"
                                        fieldWidth={500}
                                        maxLength={1023}
                                        hide={this.state.hideAdvanced}
                                        hint={false}
                                        defaultValue={asset ? asset.keyPathSubst : ''}
                                        onChange={(value: string) => this.modify({keyPathSubst: value})}
                                        readOnly={this.state.readOnly}
                                    />
                                </Accordion.Content>
                            </Accordion>
                        </Config.Section>
                    </Config.Section>
                </Config.Pane>
                <Config.Pane>
                    <Config.Section
                        id="characteristics"
                        title="Monitoring"
                    >
                        <Config.Section id="characteristics-root" title="">
                            <Config.List
                                id="."
                                caption="Alarm Template"
                                options={this.state.vodTemplates}
                                hint={false}
                                defaultValue={asset ? asset.template : 'streamDefault'}
                                onChange={(value: any) => this.modify({template: value})}
                                readOnly={this.state.readOnly}
                            />
                            {/*<Config.Checkbox*/}
                            {/*    id="."*/}
                            {/*    caption="DRM/Decryption Bypass"*/}
                            {/*    optional*/}
                            {/*    hint={false}*/}
                            {/*    hide={this.state.hideAdvanced}*/}
                            {/*    checked={asset ? asset.decryptDrmBypass : false}*/}
                            {/*    onToggle={(value: boolean) => this.modify({decryptDrmBypass: value})}*/}
                            {/*    readOnly={this.state.readOnly}*/}
                            {/*/>*/}
                            <div className="spacerFS"/>
                            <fieldset id="fieldSeta" className="field-set">
                                <legend>Decryption</legend>
                                <Grid columns={2} divided="vertically" >
                                    <Grid.Row>
                                        <Grid.Column width={12}>
                                            <Config.List
                                                id="45"
                                                caption="Mode"
                                                options={decryptOptions}
                                                className={(this.state.readOnly || globalDecryptionConfigDisabled) ? 'label-disabled' : ''}
                                                hint={false}
                                                defaultValue={asset ? asset.decryptMode : 'disable'}
                                                onChange={(value: any) => this.modify({decryptMode: value})}
                                                disabled={this.state.readOnly || globalDecryptionConfigDisabled}
                                                readOnly={this.state.readOnly}
                                            />
                                            <Config.LongText
                                                id="46"
                                                caption="Content Identifier"
                                                className={(!asset || asset.decryptMode !== 'DRM system') || (this.state.readOnly || globalDecryptionConfigDisabled) ? 'label-disabled' : ''}
                                                fieldWidth={420}
                                                maxLength={255}
                                                disabled={(!asset || asset.decryptMode !== 'DRM system') || (this.state.readOnly || globalDecryptionConfigDisabled)}
                                                hint={false}
                                                defaultValue={asset ? asset.decryptContentId : ''}
                                                onChange={(value: string) => this.modify({decryptContentId: value})}
                                                readOnly={this.state.readOnly}
                                            />
                                            <Config.LongText
                                                id="47"
                                                caption="Static Key"
                                                className={(!asset || asset.decryptMode !== 'static') || (this.state.readOnly || globalDecryptionConfigDisabled) ? 'label-disabled' : ''}
                                                fieldWidth={180}
                                                maxLength={62}
                                                disabled={(!asset || asset.decryptMode !== 'static') || (this.state.readOnly || globalDecryptionConfigDisabled)}
                                                hint={false}
                                                defaultValue={asset ? asset.decryptStaticKey : ''}
                                                onChange={(value: string) => this.modify({decryptStaticKey: value})}
                                                readOnly={this.state.readOnly}
                                            />
                                            <Config.LongText
                                                id="48"
                                                caption="Static IV"
                                                className={(!asset || asset.decryptMode !== 'static') || (this.state.readOnly || globalDecryptionConfigDisabled) ? 'label-disabled' : ''}
                                                fieldWidth={180}
                                                maxLength={62}
                                                disabled={(!asset || asset.decryptMode !== 'static') || (this.state.readOnly || globalDecryptionConfigDisabled)}
                                                hint={false}
                                                defaultValue={asset ? asset.decryptStaticIv : ''}
                                                onChange={(value: string) => this.modify({decryptStaticIv: value})}
                                                readOnly={this.state.readOnly}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={4}>
                                            {asset && (this.state.readOnly || globalDecryptionConfigDisabled) &&
                                            <Label className="left-align-label-300">
                                                {/* tslint:disable-next-line:max-line-length */}
                                                Note: Global configuration for decryption is disabled. To enable, go to Monitoring Configuration then Protocol Configuration and select the appropriate protocol. Click the checkbox to 'Enable Decryption'.
                                            </Label>}
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </fieldset>
                                <div className="spacerFS"/>
                            <fieldset id="fieldSet2" className="field-set">
                                {asset && asset.monitorMode !== 'Header Only' && asset.qoeAudio !== undefined ?
                                    <legend>Start Options and Content Analysis (QoE)</legend> :
                                    <legend>Start Options</legend>}
                                    {/*<Config.Checkbox*/}
                                    {/*    id="13"*/}
                                    {/*    caption="Auto-Start After Reset"*/}
                                    {/*    optional*/}
                                    {/*    hint={false}*/}
                                    {/*    checked={asset ? asset.autoStartOnReset : false}*/}
                                    {/*    onToggle={(value: boolean) => this.modify({autoStartOnReset: value})}*/}
                                    {/*    readOnly={this.state.readOnly}*/}
                                    {/*/>*/}
                                    <Config.RadioList
                                        id="asset.autostart"
                                        caption="Variants"
                                        hide={this.state.hideAdvanced}
                                        options={[{
                                            value: '',
                                            text: 'Global settings'
                                        }, {
                                            value: 'all',
                                            text: 'All'
                                        }, {
                                            value: 'custom',
                                            text: 'Custom'
                                        }]}
                                        defaultValue={this.state.autostart}
                                        onChange={(value: any) => { this.setState({ autostart: value }, () => this.modify({variantModified: true})); }}
                                    />
                                    {asset ? this.renderSubRepFields(asset) : []}
                                    {asset ? this.renderVariantsFields(asset) : []}
                                    {asset && asset.monitorMode !== 'Header Only' ? this.renderQoeFields(asset) : []}
                                    <div className="spacerFS"/>
                                    {asset && this.state.autostart === 'custom' ? this.renderButtons(asset.streamType) : ''}
                            </fieldset>
                            <div className="spacerFS"/>
                            <Accordion>
                                <Accordion.Title
                                    active={activeIndexes.includes(1)}
                                    index={1}
                                    onClick={this.handleClick}
                                >
                                    <Icon name="dropdown"/>
                                    Advanced
                                </Accordion.Title>
                                <Accordion.Content active={activeIndexes.includes(1)}>
                                    <fieldset id="fieldSet3" className="field-set">
                                        <legend>Custom Request Headers</legend>
                                        {asset ? this.renderCustomHeaderFields(asset.streamType) : []}
                                        <div className="spacerFS"/>
                                        <Button
                                            floated="left"
                                            className="leftButton"
                                            disabled={Object.keys(this.state.headers).length < 8 ? false : true}
                                            content="Add"
                                            title="Add Header"
                                            onClick={(e, data) => this.addHeader(Object.keys(this.state.headers).length)}
                                        />
                                        <Button
                                            floated="left"
                                            className="leftButton"
                                            disabled={Object.keys(this.state.headers).length === 0 ? true : false}
                                            content="Remove All"
                                            title="Remove All Headers"
                                            onClick={(e, data) => this.removeHeaders()}
                                        />
                                    </fieldset>
                                    <div className="spacerFS"/>
                                    <fieldset id="fieldSet4" className="field-set">
                                        <legend>HTTP Request Settings</legend>
                                        <Config.LongText
                                            id="."
                                            caption="Query String Token"
                                            fieldWidth={500}
                                            maxLength={1023}
                                            disabled={false}
                                            hide={this.state.hideAdvanced}
                                            hint={false}
                                            defaultValue={asset ? asset.tokens : ''}
                                            onChange={(value: string) => this.modify({tokens: value})}
                                            readOnly={this.state.readOnly}
                                            placeholder="tk<id>=<tokenString>"
                                        />
                                        <Config.LongText
                                            id="."
                                            caption="Miscellaneous"
                                            fieldWidth={500}
                                            maxLength={1023}
                                            hide={this.state.hideAdvanced}
                                            hint={false}
                                            defaultValue={asset ? asset.misc : ''}
                                            onChange={(value: string) => this.modify({misc: value})}
                                            readOnly={this.state.readOnly}
                                        />
                                        <Config.LongText
                                            id="."
                                            caption="Host (Primary)"
                                            fieldWidth={500}
                                            maxLength={127}
                                            hide={this.state.hideAdvanced}
                                            hint={false}
                                            defaultValue={asset ? asset.hostReqHdrPri : ''}
                                            onChange={(value: string) => this.modify({hostReqHdrPri: value})}
                                            readOnly={this.state.readOnly}
                                        />
                                        <Config.LongText
                                            id="."
                                            caption="Host (Secondary)"
                                            fieldWidth={500}
                                            maxLength={127}
                                            hide={this.state.hideAdvanced}
                                            hint={false}
                                            defaultValue={asset ? asset.hostReqHdrSec : ''}
                                            onChange={(value: string) => this.modify({hostReqHdrSec: value})}
                                            readOnly={this.state.readOnly}
                                        />
                                        <Config.LongText
                                            id="."
                                            caption="User Agent"
                                            fieldWidth={500}
                                            maxLength={255}
                                            hide={this.state.hideAdvanced}
                                            hint={false}
                                            defaultValue={asset ? asset.userAgent : ''}
                                            onChange={(value: string) => this.modify({userAgent: value})}
                                            readOnly={this.state.readOnly}
                                        />
                                </fieldset>
                                <div className="spacerFS"/>
                                <Config.LongText
                                    id="."
                                    caption="Expected Number Variants/Profiles"
                                    fieldWidth={170}
                                    maxLength={8}
                                    hide={this.state.hideAdvanced}
                                    hint={false}
                                    defaultValue={asset ? asset.profiles : ''}
                                    onChange={(value: string) => this.modify({profiles: value})}
                                    readOnly={this.state.readOnly}
                                />
                                <Config.TimeDuration
                                    id="."
                                    caption="Duration"
                                    fieldWidth={170}
                                    hide={this.state.hideAdvanced}
                                    hint={false}
                                    defaultValue={(asset && asset.vod) ? asset.vod.duration : ''}
                                    onChange={(value: string) => this.modify( { vod: { ...asset.vod, duration: value}})}
                                    readOnly={this.state.readOnly}
                                />
                                <Config.Checkbox
                                    id="."
                                    caption="CDN Caching Measurements"
                                    optional
                                    hide={this.state.hideAdvanced}
                                    hint={false}
                                    checked={asset ? asset.cdnCacheMeasurements : false}
                                    onToggle={(value: boolean) => this.modify({cdnCacheMeasurements: value})}
                                    readOnly={this.state.readOnly}
                                />
                            </Accordion.Content>
                        </Accordion>
                        <div className="spacerFS"/>
                        <Accordion>
                            <Accordion.Title
                                active={activeIndexes.includes(2)}
                                index={2}
                                onClick={this.handleClick}
                            >
                                <Icon name="dropdown"/>
                                Configuration
                            </Accordion.Title>
                                <Accordion.Content active={activeIndexes.includes(2)}>
                                <div className="spacerFS"/>
                                <fieldset id="fieldSet4" className="field-set">
                                    <legend>File Mode</legend>
                                         <Config.RadioList
                                             id="."
                                             caption=""
                                             hint={false}
                                             options={[{
                                                 value: 'ALL',
                                                 text: 'All - Request every segment'
                                             }, {
                                                 value: 'PARTIAL BLOCKS',
                                                 text: 'Partial – Request segments from beginning, middle, and end as configured in global settings'
                                             }, {
                                                 value: 'EXPIRED',
                                                 text: 'Expired – Validate that the media is not available on the origin/cache'
                                             }, {
                                                 value: 'ADVANCE',
                                                 text: 'Every N-th segment – Test some media files by specifying the number of segments to advance between requests'
                                             }]}
                                             defaultValue={asset && asset.vod ? asset.vod.fileMode : 'ALL'}
                                             onChange={(value: any) => this.modify({vod: {...asset.vod, fileMode: value}})}
                                             readOnly={this.state.readOnly}
                                         />
                                        <Config.Numeric2
                                            id="."
                                            caption="File Advance"
                                            charLength={8}
                                            hint={false}
                                            minimum={1}
                                            maximum={65535}
                                            disabled={!asset || !asset.vod || asset.vod.fileMode !== 'ADVANCE'}
                                            defaultValue={(asset && asset.vod) ? asset.vod.fileAdvance : 1}
                                            onChange={(value: number) => this.modify( { vod: { ...asset.vod, fileAdvance: value}})}
                                            readOnly={this.state.readOnly}
                                        />
                                </fieldset>
                                <div className="spacerFS"/>
                                <fieldset id="fieldSet5" className="field-set">
                                    <legend>
                                        Speed
                                        <Modal
                                            closeIcon
                                            onClose={() => this.setSpeedModalOpen(false)}
                                            onOpen={() => this.setSpeedModalOpen(true)}
                                            open={this.state.speedModalOpen}
                                            size="small"
                                            trigger={<Icon name="question circle" size="small" />}
                                        >
                                            <Header as="h5" icon className="speedModalHeader">
                                                Speed
                                            </Header>
                                            <Modal.Content>
                                                <p>
                                                    {/* tslint:disable-next-line:max-line-length */}
                                                    This setting allows you to define how fast the content will be requested from the VOD resources. When configuring take into consideration the total volume of requests if you are running test concurrently.
                                                </p>
                                                <p>
                                                    {/* tslint:disable-next-line:max-line-length */}
                                                    <b>Asset playback duration</b> – Under good network conditions the test duration will be approximately the sum of the playback duration of all requested media files. For example, with file mode ‘All’ a 30-minute piece of media will take 30 minutes to test.
                                                </p>
                                                <p>
                                                    {/* tslint:disable-next-line:max-line-length */}
                                                    <b>Multiple file per second</b> – Test will run at an advanced speed regardless of the media playback duration. Each second the specified number of media files are requested. Use this setting in conjunction with File Mode and Validation (‘Request’) to control the overall test load.
                                                </p>
                                                <p className="paddingLeft-10">
                                                    <b>Note</b>: When Content Analysis is enabled, the files per second will be throttled by the time required to decode and analyze the media.
                                                </p>
                                            </Modal.Content>
                                        </Modal>
                                    </legend>
                                    <Config.RadioList
                                        id="."
                                        caption=""
                                        hint={false}
                                        options={[{
                                            value: 'NORMAL',
                                            text: 'Asset playback duration'
                                        }, {
                                            value: 'ADVANCE',
                                            text: 'Multiple files per second'
                                        }]}
                                        defaultValue={asset && asset.vod ? asset.vod.timeMode : 'ALL'}
                                        onChange={(value: any) => this.modify({vod: {...asset.vod, timeMode: value}})}
                                        readOnly={this.state.readOnly}
                                    />
                                    <Config.NumericButtons2
                                        id="."
                                        caption="Files Per Second"
                                        charLength={2}
                                        hint={false}
                                        minimum={1}
                                        maximum={5}
                                        disabled={!asset || !asset.vod || asset.vod.timeMode !== 'ADVANCE'}
                                        defaultValue={(asset && asset.vod) ? asset.vod.timeAdvance : 0}
                                        onChange={(value: number) => this.modify( { vod: { ...asset.vod, timeAdvance: value}})}
                                        readOnly={this.state.readOnly}
                                    />
                                </fieldset>
                                <div className="spacerFS"/>
                                <fieldset id="fieldSet6" className="field-set">
                                    <legend>Validation</legend>
                                    <Config.RadioList
                                        id="."
                                        caption=""
                                        hint={false}
                                        options={[{
                                            value: 'GET',
                                            text: 'Download full media payload'
                                        }, {
                                            value: 'HEAD',
                                            text: 'Check that media is accessible (Header Only)'
                                        }]}
                                        defaultValue={asset && asset.vod ? asset.vod.requestType : 'ALL'}
                                        onChange={(value: any) => this.modify({vod: {...asset.vod, requestType: value}})}
                                        readOnly={this.state.readOnly}
                                    />
                                </fieldset>
                            </Accordion.Content>
                        </Accordion>
                        </Config.Section>
                    </Config.Section>
                </Config.Pane>
                <div className="pageFooter"/>
                </div>
                {this.renderModal()}
                {this.renderVariantsModal()}
                {this.renderHeaderModal()}
            </React.Fragment>
        );
    }

    handleErrModalClose() {
        this.setState({
            respText: '',
            showErr: false
        });
    }

    render() {
        let asset: (IAsset | null) = (this.state.assets !== undefined && this.state.currentIndex !== undefined)
            ? this.state.assets[this.state.currentIndex]
            : null;
        const isNew = asset === this.state.newAsset;
        const isModified = asset ? asset.modified : false;
        const inlineStyle = {
            modal : {
                marginTop: '50px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };

        return (
            <div className="view-content min-width1430" id="assetAlias">
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">VOD Asset Aliases</div>
                        </div>
                    </div>
                </div>
                <div className="view-clientarea">
                    <div className="divided-area-main">
                        <div className="panelAssets">
                            <Input
                                className="aliasPanelSearchBox"
                                type="text"
                                value={this.state.searchString}
                                placeholder="Search Aliases..."
                                onChange={this.filterList}
                                icon={<Icon name="close" link onClick={this.clearFilter}/>}
                            />
                            <Button
                                className="rightButton"
                                icon={<Icon name="trash alternate outline" color={'red'} link />}
                                content="Delete All"
                                title="Delete All"
                                onClick={this.confirmDeleteAll}
                            />
                            <Button
                                className="leftButton"
                                icon={<Icon name="add" link />}
                                content="Add"
                                title="Add"
                                disabled={isNew || isModified}
                                onClick={() => { this.setState({ currentIndex: undefined, headers: [], autostart: '', variants: [], currentOptions: this.hlsStatusOptions }); }}
                            />
                        <AssetPanel
                            ref="assets"
                            className="assetAliasWindow stretch-vertical vh-hack"
                            assets={this.state.assets}
                            filter={this.state.searchString}
                            onClick={(clickAsset: {}, index: number) => this.handleAssetClick(clickAsset, index, isModified)}
                            iconClick={this.confirmDelete}
                            currentIndex={this.state.currentIndex}
                        />
                        </div>
                        <div className="view-content config-view flow" id="asset-alias">
                            {asset ? this.renderForm(asset) : this.renderForm(this.state.newAsset)}
                        </div>
                    </div>
                </div>
                <Modal
                    open={this.state.showModal}
                    onClose={this.handleWarningClose}
                    size="mini"
                    style={inlineStyle.modal}
                >
                    <Modal.Header>Save Changes?</Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Field>
                                Do you want to save your changes?
                            </Form.Field>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            className="filterPanel-secondary-btn modal-button-padding"
                            onClick={(event: any, data: any) => {
                                this.setState({
                                                  showModal: false
                                              },() => {
                                    this.transformVariants(2, asset);
                                });
                            }}
                        >
                            Yes
                        </Button>
                        <Button
                            className="filterPanel-primary-btn modal-button-padding"
                            onClick={(event: any, data: any) => {
                                this.setState({
                                                  showModal: false
                                              },() => {
                                    this.handleRevertAsset();
                                });
                            }}
                        >
                            No
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.showErr}
                    onClose={this.handleErrModalClose}
                    size="mini"
                    style={inlineStyle.modal}
                >
                    <Modal.Header>Error</Modal.Header>
                    <Modal.Content>
                        {this.state.respText}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.handleErrModalClose}>
                            OK
                        </Button>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }

    handleRevertAsset() {
        if (this.state.assets && this.state.currentIndex !== undefined) {
            let asset = this.state.currentAsset;
            asset.modified = false;
            const newState = update(this.state, {
                assets: {[this.state.currentIndex]: {$merge: asset}}
            });
            this.setState(newState);
            this.setState({ currentIndex: this.state.nextIndex, currentAsset: this.state.nextAsset, assetName: this.state.nextName });
            this.extractCustomHeaders(this.state.nextIndex);
            this.extractVariants(this.state.nextIndex);
            this.extractOptions(this.state.nextIndex);
        }
    }

    modify(asset: any, hideUpdate?: boolean) {
        if (!(this.state.assets && this.state.assets.length === 0 && this.state.currentIndex === 0)) {
            if (this.state.assets && this.state.currentIndex !== undefined) {
                // update the state of the current asset
                if (!hideUpdate) {
                    asset.modified = true;  // will mark the asset as modified and turn red
                }
                const newState = update(this.state, {
                    assets: {[this.state.currentIndex]: { $merge: asset }}
                });
                this.setState(newState);
            } else {
                if (!hideUpdate) {
                    asset.modified = true;  // will mark the asset as modified and turn red
                }
                const newState = update(this.state, {
                    newAsset: {$merge: asset}
                });
                this.setState(newState);
            }
        }
    }

    updateAliases(event: any, data: any) {
        if (this.state.assets && this.state.newAsset.modified) {
            // add the new object to the state before performing the update
            this.setState({
                assets: [ ...this.state.assets, this.state.newAsset],   // add new asset to list
                // currentIndex: 0,
                assetName: this.state.newAsset.name,
                newAsset: Asset.VodAsset()  // reset the new asset object
            },            () => {
                // when state is modified, then issue the update remotely
                return this.updateAliases(event, data);
            });
        }
        let modifiedAssets = this.state.assets && this.state.assets.filter( a => a.modified );
        if (modifiedAssets && modifiedAssets.length > 0) {
            let url = 'http://default/api/vod/aliases';
            axios.post(url, {vodAliases: modifiedAssets})
            // an interceptor handles errors for us
                .then((response: any) => {
                    if (modifiedAssets && this.state.assets && (response.data !== undefined) && (response.data.code === 'SUCCESS')) {
                        // combine our current asset array with the updated assets in the response
                        const updatedAssets: IAsset[] = response.data.vodAliases;
                        const updatedIds = updatedAssets.map( a => a.id );
                        let assets = this.state.assets.map( a => {
                            a.modified = false;
                            a.headerModified = false;
                            a.variantModified = false;
                            const pos = updatedIds.indexOf(a.id);
                            return (pos >= 0) ? updatedAssets[pos] : a;
                        });
                        this.setState({ assets, isError: false });
                        this.fetchData(modifiedAssets[0].name, false);

                    } else throw response;

                })
                .catch( (error) =>  {
                    let errText = (error.data && error.data.det) ? error.data.det : (error.response && error.response.data && error.response.data.det) ? error.response.data.det : 'Error: check console.';
                    console.log('Error: ', error);
                    this.setState({
                        respText: errText,
                        showErr: true,
                        isError: true
                    });
                });
        }
    }

    addAlias(asset: IAsset) {
        let url = 'http://default/api/vod/alias/' + encodeURIComponent(asset.name);
        axios.post(url, {
            vodAlias: asset
        })
            .then((response: AxiosResponse) => {
                if (response.data !== undefined && this.state) {
                    let addedAsset = response.data.vodAlias;
                    this.setState({
                        // add newAsset (that user just filled in) to the list of assets
                        assets: this.state.assets ? this.state.assets.concat(addedAsset) : [addedAsset],
                        // set the currently selected asset to the newly added asset index above
                        // currentIndex: this.state.assets ? this.state.assets.length : 0,
                        // currentIndex: 0,
                        // if we are adding the 'newAsset', then create a new Asset object as the new state.newAsset
                        isError: false,
                        newAsset: (this.state.newAsset === asset) ? Asset.VodAsset() : this.state.newAsset
                    });
                    this.fetchData(asset.name, false);

                } else throw response;

            })
            .catch( (error) =>  {
                let errText = (error.data && error.data.det) ? error.data.det : (error.response && error.response.data && error.response.data.det) ? error.response.data.det : 'Error: check console.';
                console.log('Error: ', error);
                this.setState({
                    respText: errText,
                    showErr: true,
                    isError: true
                });
            });
    }

    deleteAllAliases() {
        axios.delete('http://default/api/vod/aliases/purge')
            .then((response: any) => {
                if ((response.data !== undefined) && (response.data.code === 'SUCCESS')) {
                    this.setState({ assets: [], currentIndex: undefined });
            } else throw response;

        }).catch( (error) =>  {
            let errText = (error.data && error.data.det) ? error.data.det : (error.response && error.response.data && error.response.data.det) ? error.response.data.det : 'Error: check console.';
            console.log('Error: ', error);
            this.setState({
                respText: errText,
                showErr: true
            });
        });
    }

    deleteAlias(event: any, data: IAsset) {
        // @ts-ignore
        let id = data.aliasId.toString();
        axios.delete( 'http://default/api/vod/alias/' + encodeURIComponent(id))
            .then((rsp: AxiosResponse) => {
                if ((rsp.data !== undefined) && (rsp.data.code === 'SUCCESS')) {
                    if (this.state.assets) {
                        this.setState({assets: this.state.assets.filter(a => a.name !== data.name)}, () => this.state.assets && this.state.assets.length === 0 ? this.setState({currentIndex: undefined}) : null);
                    }
                } else throw rsp;

            }).catch( (error) =>  {
            let errText = (error.data && error.data.det) ? error.data.det : (error.response && error.response.data && error.response.data.det) ? error.response.data.det : 'Error: check console.';
            console.log('Error: ', error);
                this.setState({
                    respText: errText,
                    showErr: true
                });
        });
    }

    handleClick = (e: any, titleProps: any) => {
        const { index } = titleProps;
        const { activeIndexes } = this.state;
        const newIndex = activeIndexes;

        const currentIndexPosition = activeIndexes.indexOf(index);
        if (currentIndexPosition > -1) {
            newIndex.splice(currentIndexPosition, 1);
        } else {
            newIndex.push(index);
        }

        this.setState({ activeIndexes: newIndex });
    }

    saveAs() {
        let alreadyExists = this.state && this.state.confirmation && _.find(this.state.assets, { 'name': this.state.confirmation.value });
        if (this.state && this.state.confirmation && this.state.confirmation.value && !alreadyExists) {
        if (!this.state || !this.state.assets) return;
        let asset = (this.state.currentIndex !== undefined && this.state.currentIndex >= 0)
            ? this.state.assets[this.state.currentIndex]
            : this.state.newAsset;
        this.addAlias({ ...asset, id: undefined, name: this.state.confirmation.value });
        }
    }

    handleHeaderModalClose() {
        this.setState({
          showHeaderModal: false
        });
    }

    handleVariantsModalClose() {
        this.setState({
          showVariantsModal: false
        });
    }

    handleAssetClick(asset: any, index: number, isModified: boolean) {
        if (isModified) {
            this.setState({showModal: true, nextAsset: asset, nextIndex: index, nextName: asset.name});
        } else {
            // simply switch state to new asset
            this.setState({ currentIndex: index, currentAsset: asset, assetName: asset.name });
            this.extractCustomHeaders(index);
            this.extractVariants(index);
            this.extractOptions(index);
        }
    }

    formatDate(date: any) {
        const monthNames = [
            'January', 'February', 'March',
            'April', 'May', 'June', 'July',
            'August', 'September', 'October',
            'November', 'December'
        ];

        let day = date.getDate();
        let monthIndex = date.getMonth();
        let year = date.getFullYear();
        let hours = date.getHours();
        let mins = date.getMinutes();
        let secs = date.getSeconds();

        return day + ' ' + monthNames[monthIndex] + ' ' + year + ' ' + hours + ':' + mins + ':' + secs;
    }

    setCurrentIndex(name: string) {
        let index;
        if (name === 'SABR' && this.state.assets && this.state.assets.length > 0) {
            index = 0;
        } else if (name === 'SABR' && this.state.assets && this.state.assets.length === 0) {
            index = undefined;
        } else {
            // find name in list to get index
            index = this.state.assets ? this.state.assets.findIndex(x => x.name === name) ? this.state.assets.findIndex(x => x.name === name) : 0 : 0;
        }
        // use index to retrieve current asset.
        let asset: (IAsset | null) = (this.state.assets !== undefined && index !== undefined)
            ? this.state.assets[index]
            : null;

        this.setState({
          currentIndex: index,
          currentAsset: asset
        });
    }

    setDecryptMode(aliases: any) {
        let assets = aliases.sort(VODAssetAliasView.compare);
        assets.forEach( (asset: { decryptMode: string; }) => asset.decryptMode = 'disable' );
        this.setState({ assets });
    }
    // The sort via 'x-orderby' header does not appear to be currently working for /vod/aliases.
    // I will need the first 20 aliases to be already sorted by name in ascending order.
    // The code is currently sorting it locally, so maybe there's a good reason why the sort is not working in the API.
    fetchData(name ?: string, firstTime ?: boolean) {
        let _this = this;
        // tslint:disable-next-line:no-console
        // console.log(this.formatDate(new Date()) + ': fetchData()');  // show current date-time in console
        // Only load the first 20 aliases. Schedule full load immediately after.
        if (firstTime) {
            axios.get('http://default/api/vod/aliases?limit=20')
                // {headers: {'x-orderby': 'order vodAliases by name'}})
                .then((response: AxiosResponse) => {
                    if (response.data !== undefined) {
                        // _this.setDecryptMode(response.data.vodAliases);
                        this.setState({
                          assets: response.data.vodAliases.sort(VODAssetAliasView.compare)
                        });
                        if (name) {
                            _this.setCurrentIndex(name);
                        }
                        _this.extractCustomHeaders(_this.state.currentIndex);
                        _this.extractVariants(_this.state.currentIndex);
                        _this.extractOptions(_this.state.currentIndex);
                        // tslint:disable-next-line:no-console
                        // console.log(this.formatDate(new Date()) + ': Fetch first 20 VOD Aliases');  // show current date-time in console
                    } else {
                        // tslint:disable-next-line:no-console
                        console.log('request error: ', response.data);
                    }
                }).catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetch data error, got: ', error);
            });
        }

        axios.get('http://default/api/vod/aliases')
            .then((response: AxiosResponse) => {
                if (response.data !== undefined) {
                    // _this.setDecryptMode(response.data.vodAliases);
                    this.setState({
                      assets: response.data.vodAliases.sort(VODAssetAliasView.compare)
                    });
                    if (name) {
                        _this.setCurrentIndex(name);
                    }
                    _this.extractCustomHeaders(_this.state.currentIndex);
                    _this.extractVariants(_this.state.currentIndex);
                    _this.extractOptions(_this.state.currentIndex);
                    // tslint:disable-next-line:no-console
                    // console.log(this.formatDate(new Date()) + ': Fetch ALL VOD Aliases');  // show current date-time in console
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('request error: ', response.data);
                }
            }).catch(function (error: AxiosRequestConfig) {
            // tslint:disable-next-line:no-console
            console.log('vod aliases error, got: ', error);
        });
    }

    fetchSetOptions() {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';
        axios.post(url, {
            mode: 'get',
            defaults: {
            },
            options:  [
                { 'name': 'setName', 'input': 1},
                { 'name': 'setName', 'input': 2},
                { 'name': 'setName', 'input': 3},
                { 'name': 'setName', 'input': 4},
                { 'name': 'setName', 'input': 5},
                { 'name': 'setName', 'input': 6},
                { 'name': 'setName', 'input': 7},
                { 'name': 'setName', 'input': 8},
                { 'name': 'setName', 'input': 9},
                { 'name': 'setName', 'input': 10}
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;
                    let name = _.map((responseObject), 'value');
                    let result = [];

                    for (let i = 0; i < name.length; i++) {
                        result.push({key: i + 1, value: name[i], text: name[i]});
                    }
                    _this.setState({
                        setOptions: result,
                        newAsset: Asset.VodAsset()
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of set names, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('setFilter() error: ', error);
            });
    }

    // put headers back into string format separated by semicolons
    // mimeHdrExt field: me<type>=<value>; ...
    transformHeaders(type: number, variantsString: string, videoVariants: string, pixelVariants: string, audioVariants: string, qoeAudio: boolean, qoeVideo: boolean, qoePixel: boolean) {
        let _this = this;
        let expression = '';
        let header = '';

        // custom header data
        for (let i = 0; i < Object.keys(this.state.headers).length; i++) {
            header = this.state.headers[i].type !== undefined && this.state.headers[i].type !== '' ? this.state.headers[i].type + '=' +  this.state.headers[i].value : '';
            header = header.trim();
            expression += header + ';';
        }

        // add final formatting
        if (expression !== '') {
            expression = expression.substring(0, expression.length - 1);
        }

        // ensure mimeHdrExt string is not greater than 1023 characters
        if (expression.length > 1023) {
            _this.setState({showHeaderModal: true});
        } else {
            _this.modify( {mimeHdrExt: expression, variants: variantsString, qoeVideoVariants: videoVariants, qoePixelVariants: pixelVariants, qoeAudioVariants: audioVariants, qoeAudio: qoeAudio, qoeVideo: qoeVideo, qoePixel: qoePixel});
            if (type === 1) {
                _this.confirmSaveAs();
            } else {
                _this.confirmSave();
            }
        }
    }

    // extract headers from 'mimeHdrExt' string
    extractCustomHeaders(index: any) {
        let asset: (IAsset | null) = (this.state.assets !== undefined && this.state.currentIndex !== undefined)
            ? this.state.assets[index]
            : null;

        // console.log('index: ' + index);

        let expression = asset ? asset.mimeHdrExt : '';

        this.setState((prevState) => ({
            headers: []
        }));

        // expression = 'me1=Tag1:Value1;me2=Tag2:Value2;me3=Tag3:Value3';
        // expression = 'me1=one;me2=two;me3=x;me3=y';
        // expression = 'me2=One;me1=Two:Two;me2=-media';
        // expression = 'me1=Tag1:Str1=Str2;me2=Tag2:Value2;me3=Three;me4=-media';
        if (expression !== '') {
            // extract each value based on token (me<id>=)
            // SAN-5578, SAN-5388
            let config = expression.split(';');
            for (let idx = 0; idx < Object.keys(config).length; idx++) {
                // SAN-5688: allow '=' in value token.
                let id = config[idx].substring(0, 3);
                let value = config[idx].substring(4);
                if (idx < (Object.keys(config).length - 1) && (value.endsWith(';') || value.endsWith(','))) {
                    value = value.substring(0, value.length - 1);
                }
                this.setState((prevState) => ({
                    headers: [...prevState.headers, {key: idx, id: idx, type: id, value: value}],
                }));
            }
            // console.log('extractCustomHeaders: ' + expression);
        }
    }

    fetchTemplateOptions() {
        let _this = this;
        let url = 'http://default/api/config/templates/adp';
        axios.get(url, {headers: {'x-orderby': 'order templates by name'}})
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined) {
                    let templates = response.data.templates;
                    _.forEach(templates, (item: any) => {item.text = item.name; item.value = item.name; });
                    let templateList = _.filter(templates, (item: any) => { return item.mode === 'vod' || item.mode === 'any'; });

                    _this.setState({
                        vodTemplates: templateList
                    });
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('fetchTemplateOptions error: ', response.data);
                }
            }).catch(function (error: AxiosRequestConfig) {
            // tslint:disable-next-line:no-console
            console.log('fetchTemplateOptions() error: ', error);
        });
    }

    fetchGlobalConfigData() {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';
        axios.post(url, {
            mode: 'get',
            defaults: {
            },
            options: ['dashDecrypt', 'hlsDecrypt', 'hssDecrypt']
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;

                    _this.setState({
                        dashDecrypt: responseObject[0].value, hlsDecrypt: responseObject[1].value,
                        hssDecrypt: responseObject[2].value
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });

    }

    toggleAdvancedProps(event: any, data: any) {
        this.setState({
            hideAdvanced: !data.checked
        });
    }

    renderModal() {
        const inlineStyle = {
            modal : {
                marginTop: '20px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        let options = this.state && this.state.confirmation;
        if (!options) return null;
        return (
            <Modal
                open
                size="small"
                style={inlineStyle.modal}
            >
                <Modal.Header>{options.headerText}</Modal.Header>
                <Modal.Content>
                    <Form>
                        {(typeof options.content === 'function') ? options.content.call(this, options) : <p>{options.content}</p>}
                        <p>
                            <em><b>Note:</b> For this action to persist across probe restart, you must 'Save Configuration'
                            from the System settings menu (System --> Save Config).</em>
                        </p>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        className="filterPanel-primary-btn modal-button-padding"
                        onClick={(event: any, data: any) => {
                            // close the modal
                            this.setState({confirmation: undefined });
                            // execute the onAccept event, the event and data fields are already bound to onAccept()
                            if (options && options.onAccept) options.onAccept();
                        }}
                    >
                        {options.ConfirmButton || 'Yes'}
                    </Button>
                    <Button
                        className="filterPanel-secondary-btn modal-button-padding"
                        onClick={(event: any, data: any) => {
                            // close the modal
                            this.setState({confirmation: undefined });
                        }}
                    >
                        {options.CancelButton || 'Cancel'}
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }

    renderHeaderModal() {
            const inlineStyle = {
                modal : {
                    marginTop: '20px !important',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                }
            };
            return (
                <Modal
                    open={this.state.showHeaderModal}
                    onClose={this.handleHeaderModalClose}
                    size="mini"
                    style={inlineStyle.modal}
                >
                    <Modal.Header>Error!</Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Field>
                                The Custom Headers configuration is too long (> 1023). Please correct the configuration and hit Apply.
                            </Form.Field>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.handleHeaderModalClose}>
                            OK
                        </Button>
                    </Modal.Actions>
                </Modal>
            );
    }

    renderVariantsModal() {
        const inlineStyle = {
            modal : {
                marginTop: '20px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        return (
            <Modal
                open={this.state.showVariantsModal}
                onClose={this.handleVariantsModalClose}
                size="mini"
                style={inlineStyle.modal}
            >
                <Modal.Header>Error</Modal.Header>
                <Modal.Content>
                    <Form>
                        <Form.Field>
                            The Auto-Start Variants configuration is too long (> 255). Please modify the configuration and hit Apply.
                        </Form.Field>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.handleVariantsModalClose}>
                        OK
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }

    private showConfirmation(options: ModalConfirmOptions, event: any, data: any) {
        if (!this.props.confirmation)
            return options.onAccept.call(this, event, data);
        if (event)
            event.stopPropagation();
        // console.log("showing confirmation for ", { options, event, data });
        // setup the state to show the confirmation box
        this.setState({
            confirmation: { ...options, onAccept: options.onAccept.bind(this, event, data) }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/vodAssetAlias.tsx